<template>
  <svg
    width="208"
    height="172"
    viewBox="0 0 104 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.9936 0H17.2007C7.70103 0 0 7.70103 0 17.2007V68.7928C0 78.2925 7.70103 85.9936 17.2007 85.9936H85.9936C95.4933 85.9936 103.194 78.2925 103.194 68.7928V17.2007C103.194 7.70103 95.4933 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g style="mix-blend-mode:hard-light">
      <path
        d="M103.194 17.1906L93.2424 19.671C66.4744 26.1706 39.3217 32.6804 13.0094 38.9877C8.66617 40.0304 4.32296 41.0732 0 42.1059V17.1906C0 7.68414 7.70439 0 17.2109 0H86.0037C95.5101 0 103.194 7.69427 103.194 17.1906Z"
        fill="url(#paint0_linear_9_1027)"
      />
    </g>
    <path
      d="M33.5712 58.3447C39.2687 58.3447 43.8875 53.7259 43.8875 48.0283C43.8875 42.3307 39.2687 37.7119 33.5712 37.7119C27.8736 37.7119 23.2548 42.3307 23.2548 48.0283C23.2548 53.7259 27.8736 58.3447 33.5712 58.3447Z"
      fill="#4CE0B3"
    />
    <path
      d="M69.633 58.4466C75.3306 58.4466 79.9494 53.8278 79.9494 48.1302C79.9494 42.4327 75.3306 37.8138 69.633 37.8138C63.9355 37.8138 59.3167 42.4327 59.3167 48.1302C59.3167 53.8278 63.9355 58.4466 69.633 58.4466Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.5712 53.1926C36.4228 53.1926 38.7345 50.8809 38.7345 48.0293C38.7345 45.1778 36.4228 42.8661 33.5712 42.8661C30.7196 42.8661 28.408 45.1778 28.408 48.0293C28.408 50.8809 30.7196 53.1926 33.5712 53.1926Z"
      fill="#A6F4D8"
    />
    <path
      d="M69.6331 53.2937C72.4847 53.2937 74.7964 50.982 74.7964 48.1304C74.7964 45.2788 72.4847 42.9672 69.6331 42.9672C66.7815 42.9672 64.4698 45.2788 64.4698 48.1304C64.4698 50.982 66.7815 53.2937 69.6331 53.2937Z"
      fill="#A6F4D8"
    />
    <path
      d="M20.7947 37.6821C20.1771 37.6821 19.5494 37.4493 19.0837 36.9734C18.1321 36.0218 18.1321 34.493 19.0837 33.5414C22.8398 29.7854 27.8208 27.6593 33.1258 27.5479C34.4419 27.4872 35.5758 28.5806 35.6062 29.9271C35.6365 31.2635 34.5735 32.3771 33.227 32.4075C29.1774 32.4986 25.3708 34.1184 22.5158 36.9835C22.04 37.4594 21.4224 37.6922 20.7947 37.6922V37.6821Z"
      fill="#4CE0B3"
    />
    <path
      d="M82.3994 37.7938C83.0169 37.7938 83.6446 37.5609 84.1103 37.0851C85.062 36.1335 85.062 34.6047 84.1103 33.6531C80.3543 29.8971 75.3733 27.771 70.0683 27.6596C68.7522 27.5989 67.6183 28.6923 67.5879 30.0388C67.5575 31.3752 68.6206 32.4888 69.9671 32.5192C74.0167 32.6103 77.8233 34.2301 80.6783 37.0952C81.1541 37.5711 81.7717 37.8039 82.3994 37.8039V37.7938Z"
      fill="#4CE0B3"
    />
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M16.8157 47.7858C16.9372 34.8574 24.5403 24.4094 33.7937 24.4398C43.0471 24.4803 50.4477 34.989 50.3262 47.9275C50.2047 60.8559 42.6016 71.3039 33.3482 71.2736C24.0949 71.2331 16.6942 60.7243 16.8157 47.7858Z"
        fill="url(#paint1_radial_9_1027)"
      />
    </g>
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M53.2626 47.7855C53.3841 34.8572 60.9872 24.4091 70.2406 24.4395C79.494 24.48 86.8946 34.9888 86.7731 47.9273C86.6516 60.8557 79.0485 71.3037 69.7951 71.2733C60.5418 71.2328 53.1411 60.7241 53.2626 47.7855Z"
        fill="url(#paint2_radial_9_1027)"
      />
    </g>
    <path
      d="M85.9936 2.42977C94.1434 2.42977 100.765 9.06101 100.765 17.2007V68.8029C100.765 76.9528 94.1333 83.5739 85.9936 83.5739H17.2007C9.05088 83.5739 2.42976 76.9427 2.42976 68.8029V17.2007C2.42976 9.05089 9.06101 2.42977 17.2007 2.42977H85.9936ZM85.9936 0H17.2007C7.70439 0 0 7.70439 0 17.2007V68.8029C0 78.2993 7.70439 86.0037 17.2007 86.0037H85.9936C95.4899 86.0037 103.194 78.2993 103.194 68.8029V17.2007C103.194 7.70439 95.5 0 85.9936 0Z"
      fill="#0B132B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9_1027"
        x1="125.012"
        y1="-14.9633"
        x2="18.5675"
        y2="22.8601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2853E1" />
        <stop
          offset="1"
          stop-color="#2853E1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9_1027"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6114 47.5836) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9_1027"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.0583 47.5834) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
